import { IconLock } from '@developerz/ui';
import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import type { EmailRouteResolved } from '../lib/emailRoutes';
import type { EmailRouteCategoryMeta } from './EmailRouteRow';
import { StatusPill } from './StatusPill';

// The text block of one routing row: the "Category — destination" title line
// plus the meta line (config key, Default/Override chip, cadence, lock). Pure
// presenter — the row owns state and actions. While the row is editing, the
// destination is elided; the inline form owns it.

export function RouteDestView(props: {
  meta: EmailRouteCategoryMeta;
  resolved: EmailRouteResolved;
  editing: boolean;
}): JSX.Element {
  return (
    <span class="email-route__text">
      <span class="email-route__title">
        {t(props.meta.descKey)}
        <Show when={!props.editing}>
          <span class="email-route__sep" aria-hidden="true">
            —
          </span>
          <span
            class="email-route__dest"
            classList={{ 'email-route__dest--unset': !props.resolved.destination }}
          >
            {props.resolved.destination ?? t('email_routes.no_default')}
          </span>
        </Show>
      </span>
      <span class="email-route__meta">
        <code class="email-route__key">{props.meta.key}</code>
        <StatusPill tone={props.resolved.is_override ? 'success' : 'neutral'}>
          {t(
            props.resolved.is_override
              ? 'email_routes.override_label'
              : 'email_routes.default_label',
          )}
        </StatusPill>
        <span>
          {t(
            props.meta.cadence === 'weekly'
              ? 'email_routes.cadence_weekly'
              : 'email_routes.cadence_immediate',
          )}
        </span>
        <Show when={props.meta.locked}>
          <IconLock
            class="email-route__lock"
            size="0.75rem"
            label={t('email_routes.locked_aria')}
          />
        </Show>
      </span>
    </span>
  );
}
